import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const setMarkRead = async (chatRoomId: string) => {
  return mutationExecute({
    variables: {
      chatRoomId,
    },
    mutation: graphql(`
      mutation MarkRead($chatRoomId: String!) {
        markRead(chatRoomId: $chatRoomId) {
          id
        }
      }
    `),
  });
};
